import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SubscriptionStore } from './subscriptionStore';

// currentPlan: null,
// isLoading: true, // Start with true to prevent flash of SubscriptionPrompt before plan is fetched
// error: null,
// setCurrentPlan: (plan) =>
//     set({
//         currentPlan: plan,
//         error: null, // Clear any previous errors
//     }),
// setLoading: (loading) =>
//     set({
//         isLoading: loading,
//     }),
// setError: (error) =>
//     set({
//         error,
//         isLoading: false,
//     }),
// clearSubscription: () =>
//     set({
//         currentPlan: null,
//         isLoading: false,
//         error: null,
//     }),


export const useSubscriptionStore = create<SubscriptionStore>()(
    persist(
        (set) => ({
            currentPlan: null,
            subscriptionDetails: null,
            isLoading: true, // Start with true to prevent flash of SubscriptionPrompt before plan is fetched
            error: null,
            setCurrentPlan: (plan) =>
                set({
                    currentPlan: plan,
                    error: null, // Clear any previous errors
                }),
            setSubscriptionDetails: (details) =>
                set({
                    subscriptionDetails: details,
                }),
            setLoading: (loading) =>
                set({
                    isLoading: loading,
                }),
            setError: (error) =>
                set({
                    error,
                    isLoading: false,
                }),
            clearSubscription: () =>
                set({
                    currentPlan: null,
                    subscriptionDetails: null,
                    isLoading: false,
                    error: null,
                }),
        }),
        {
            name: 'subscription-storage',
        }
    )
);